export const setCssVariables = () => {
    const navbar = document.querySelector(".navbar")
    const foot = document.querySelector(".footer")
    const sessionHead = document.querySelector(".session-header")

    const navHeight = navbar ? parseFloat(getComputedStyle(navbar).height) : 0;
    const footerHeight = foot ? parseFloat(getComputedStyle(foot).height)  : 0;
    const sessionHeadHeight = sessionHead ? parseFloat(getComputedStyle(sessionHead).height) + (parseFloat(getComputedStyle(sessionHead).margin) * 2) : 0;

    const calculatedHeight = window.innerHeight - (navHeight + footerHeight);

    // These four are *measured* heights of real rendered chrome (nav/footer/
    // session-header) that vary with content and i18n; CSS can't derive them, so
    // they stay JS-driven. Viewport height itself is now CSS-owned via --app-vh
    // (svh), so we no longer set --window-height or force html/body heights here.
    document.documentElement.style.setProperty('--wrapper-children-height', `${calculatedHeight}px`);
    document.documentElement.style.setProperty('--nav-height', Math.floor(navHeight) + "px");
    document.documentElement.style.setProperty('--footer-height', footerHeight + "px");
    document.documentElement.style.setProperty('--session-header-height', sessionHeadHeight + 'px')
}